export default __webpack_public_path__ + "static/media/demo3.0033e67c.mp4";